import { type RefObject, useLayoutEffect } from 'react';

import {
  disableSubtreeTabIndex,
  restoreSubtreeTabIndex,
} from './mobileMenuFocusHelpers';

export function useMobileMenuPanelTabIndex(
  panelRef: RefObject<HTMLDivElement | null>,
  isOpen: boolean,
): void {
  useLayoutEffect(() => {
    const root = panelRef.current;
    if (!root) {
      return;
    }

    if (isOpen) {
      restoreSubtreeTabIndex(root, 'mobileMenuTabindexBackup');
    } else {
      disableSubtreeTabIndex(root, 'mobileMenuTabindexBackup');
    }
  }, [isOpen]);
}

export function useMobileMenuDrawerBottomTabIndex(
  bottomMenuRef: RefObject<HTMLDivElement | null>,
  isOpen: boolean,
  isOpenSubDrawer: boolean,
): void {
  useLayoutEffect(() => {
    const root = bottomMenuRef.current;
    if (!root || !isOpen) {
      return;
    }

    if (isOpenSubDrawer) {
      disableSubtreeTabIndex(root, 'mobileMenuDrawerBottomBackup');
    } else {
      restoreSubtreeTabIndex(root, 'mobileMenuDrawerBottomBackup');
    }
  }, [isOpen, isOpenSubDrawer]);
}
